export default {
    state: {
        steps: [],
    },
    mutations: {
        setHeaders(state, steps) {
            state.steps = steps;
        },
        updateStepStatus(state, payload) {
            const { index, valid } = payload;
            if (valid && index >= 0) {
                state.steps[index].completed = valid;
            }
        },
    },
    actions: {
        setSteps({ commit }, steps) {
            commit('setHeaders', steps);
        },
        updateStep({ commit }, payload) {
            commit('updateStepStatus', payload);
        },
    },
    getters: {
        getSteps: state => state.steps,
    },
};
